<section class="site-query-page">
  <app-section-header title="{{ 'siteQuery.title' | translate }}"></app-section-header>

  <header class="page-heading">
    <div>
      <button mat-button type="button" class="back-link" (click)="cancel()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'siteQuery.create.backToList' | translate }}
      </button>
      <h1>{{ 'siteQuery.create.heading' | translate }}</h1>
      <p>{{ 'siteQuery.create.description' | translate }}</p>
    </div>
    <span class="draft-badge">
      <mat-icon>edit_note</mat-icon>
      {{ 'siteQuery.status.DRAFT' | translate }}
    </span>
  </header>

  @if (workOrder) {
    <form #siteQueryForm="ngForm" class="site-query-form" (ngSubmit)="save()">
      <mat-card class="section-card" appearance="outlined">
        <mat-card-title class="section-title">{{ 'siteQuery.sections.jobReference' | translate }}</mat-card-title>
        <div class="field-grid">
          <div class="readonly-field">
            <label>{{ 'siteQuery.fields.documentType' | translate }}</label>
            <span>SQ</span>
          </div>
          <div class="readonly-field">
            <label>{{ 'siteQuery.fields.number' | translate }}</label>
            <span>{{ 'siteQuery.numberNotAssigned' | translate }}</span>
          </div>
          <div class="readonly-field">
            <label>{{ 'siteQuery.fields.revision' | translate }}</label>
            <span>{{ form.revision }}</span>
          </div>
          <div class="readonly-field">
            <label>{{ 'siteQuery.fields.workOrderNumber' | translate }}</label>
            <span>{{ workOrder.workOrderNumber || '-' }}</span>
          </div>
          @if (requiresManualTaskId) {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'siteQuery.fields.taskId' | translate }}</mat-label>
              <input
                matInput
                name="taskId"
                [(ngModel)]="taskId"
                required
                pattern="[0-9]{4}"
                maxlength="4"
                inputmode="numeric"
              />
              <mat-hint>{{ 'siteQuery.create.taskIdManualHint' | translate }}</mat-hint>
              <mat-error>{{ 'siteQuery.create.taskIdError' | translate }}</mat-error>
            </mat-form-field>
          } @else {
            <div class="readonly-field">
              <label>{{ 'siteQuery.fields.taskId' | translate }}</label>
              <span>{{ taskId }}</span>
            </div>
          }
          <mat-form-field appearance="outline" class="title-field">
            <mat-label>{{ 'siteQuery.fields.title' | translate }}</mat-label>
            <input matInput name="title" [(ngModel)]="form.title" required maxlength="255" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.deliveryId' | translate }}</mat-label>
            <input matInput name="deliveryId" [(ngModel)]="form.deliveryId" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.site' | translate }}</mat-label>
            <input matInput name="site" [(ngModel)]="form.site" />
          </mat-form-field>
        </div>
      </mat-card>

      <mat-card class="section-card" appearance="outlined">
        <mat-card-title class="section-title">{{ 'siteQuery.sections.classification' | translate }}</mat-card-title>
        <div class="field-grid">
          <div class="readonly-field">
            <label>{{ 'siteQuery.fields.discipline' | translate }}</label>
            <span>{{ workOrder.workCenterId || '-' }}</span>
            @if (!workOrder.workCenterId?.trim()) {
              <p class="field-hint error-hint">{{ 'siteQuery.create.workCenterMissing' | translate }}</p>
            }
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.reason' | translate }}</mat-label>
            <mat-select name="reason" [(ngModel)]="form.reason" required>
              <mat-option [value]="null">{{ 'siteQuery.selectReason' | translate }}</mat-option>
              @for (reason of reasonOptions; track reason) {
                <mat-option [value]="reason">{{ reasonTranslationKey(reason) | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.caseType' | translate }}</mat-label>
            <mat-select name="caseType" [(ngModel)]="form.caseType" required>
              @for (caseType of caseTypeOptions; track caseType) {
                <mat-option [value]="caseType">{{ caseTypeTranslationKey(caseType) | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.quantityChange' | translate }}</mat-label>
            <mat-select name="quantityChange" [(ngModel)]="form.quantityChange">
              <mat-option [value]="false">{{ 'siteQuery.no' | translate }}</mat-option>
              <mat-option [value]="true">{{ 'siteQuery.yes' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.scheduleImpact' | translate }}</mat-label>
            <mat-select name="scheduleImpact" [(ngModel)]="form.scheduleImpact">
              <mat-option [value]="false">{{ 'siteQuery.no' | translate }}</mat-option>
              <mat-option [value]="true">{{ 'siteQuery.yes' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.materialNeed' | translate }}</mat-label>
            <mat-select name="materialNeed" [(ngModel)]="form.materialNeed">
              <mat-option [value]="false">{{ 'siteQuery.no' | translate }}</mat-option>
              <mat-option [value]="true">{{ 'siteQuery.yes' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card>

      <mat-card class="section-card" appearance="outlined">
        <mat-card-title class="section-title">{{ 'siteQuery.sections.description' | translate }}</mat-card-title>
        <mat-form-field appearance="outline" class="full-width" floatLabel="always">
          <mat-label>{{ 'siteQuery.fields.description' | translate }}</mat-label>
          <textarea
            matInput
            rows="4"
            name="description"
            [(ngModel)]="form.description"
            required
            maxlength="10000"
          ></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" floatLabel="always">
          <mat-label>{{ 'siteQuery.fields.suggestedSolution' | translate }}</mat-label>
          <textarea
            matInput
            rows="4"
            name="suggestedSolution"
            [(ngModel)]="form.suggestedSolution"
            required
            maxlength="10000"
          ></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'siteQuery.fields.references' | translate }}</mat-label>
          <mat-select
            name="selectedReferences"
            multiple
            [(ngModel)]="selectedReferenceKeys"
            [disabled]="referencesLoading || referencesLoadFailed"
          >
            @for (reference of referenceOptions; track referenceKey(reference)) {
              <mat-option [value]="referenceKey(reference)">
                {{ 'siteQuery.referenceType.' + reference.type | translate }}: {{ reference.number }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (referencesLoading) {
          <p class="field-hint">{{ 'siteQuery.referencesLoading' | translate }}</p>
        } @else if (referencesLoadFailed) {
          <p class="field-hint error-hint">{{ 'siteQuery.referencesLoadError' | translate }}</p>
        } @else if (referenceOptions.length === 0) {
          <p class="field-hint">{{ 'siteQuery.noReferencesAvailable' | translate }}</p>
        }

        <div class="attachments">
          <label class="attachments-label">{{ 'siteQuery.fields.attachments' | translate }}</label>
          <input
            type="file"
            multiple
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            (change)="onFilesSelected($event)"
            [disabled]="saving"
          />
          @if (pendingFiles.length > 0) {
            <ul class="attachments-list">
              @for (file of pendingFiles; track file.name + file.size) {
                <li>
                  <span>{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                  <button mat-button color="warn" type="button" (click)="removeFile(file)" [disabled]="saving">
                    {{ 'siteQuery.removeAttachment' | translate }}
                  </button>
                </li>
              }
            </ul>
          } @else {
            <p class="field-hint">{{ 'siteQuery.noAttachments' | translate }}</p>
          }
        </div>
      </mat-card>

      <mat-card class="section-card" appearance="outlined">
        <mat-card-title class="section-title">{{ 'siteQuery.sections.submitter' | translate }}</mat-card-title>
        <div class="field-grid">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.initiatedBy' | translate }}</mat-label>
            <input matInput name="initiatedBy" [(ngModel)]="form.initiatedBy" required maxlength="255" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.company' | translate }}</mat-label>
            <input matInput name="company" [(ngModel)]="form.company" maxlength="255" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.date' | translate }}</mat-label>
            <input matInput type="datetime-local" name="queryDate" [(ngModel)]="form.queryDate" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.siteLeader' | translate }}</mat-label>
            <input matInput name="siteLeader" [(ngModel)]="form.siteLeader" maxlength="255" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'siteQuery.fields.integrationManager' | translate }}</mat-label>
            <input matInput name="integrationManager" [(ngModel)]="form.integrationManager" maxlength="255" />
          </mat-form-field>
        </div>
      </mat-card>

      <div class="form-actions">
        <button mat-stroked-button type="button" (click)="cancel()" [disabled]="saving">
          {{ 'siteQuery.cancel' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="
            saving ||
            !siteQueryForm.valid ||
            workOrderReferenceError ||
            !workOrder.workCenterId?.trim() ||
            referencesLoading ||
            referencesLoadFailed
          "
        >
          <mat-icon>save</mat-icon>
          {{ (saving ? 'siteQuery.saving' : 'siteQuery.create.save') | translate }}
        </button>
      </div>
    </form>
  } @else {
    <div class="loading-state" role="status">
      <mat-spinner diameter="36"></mat-spinner>
      <span>{{ 'siteQuery.loading' | translate }}</span>
    </div>
  }
</section>
